import { gql } from '@apollo/client'
// graphql
import { PLAN_ACTION_DETAILS_FRAGMENT } from 'graphql/planActions/queries'

export const PLAN_ACTION_CREATE_MUTATION = gql`
  mutation PLAN_ACTION_CREATE_MUTATION($input: PlanActionCreateInput!) {
    planActionCreate(input: $input) {
      ok
      data {
        id
        planId
        description
        createdAt
      }
    }
  }
`

export const PLAN_ACTION_DELETE_MUTATION = gql`
  mutation PLAN_ACTION_DELETE_MUTATION($id: ID!) {
    planActionDelete(id: $id) {
      ok
    }
  }
`

export const PLAN_ACTION_UPDATE_MUTATION = gql`
  mutation PLAN_ACTION_UPDATE_MUTATION($id: ID!, $input: PlanActionUpdateInput!) {
    planActionUpdate(id: $id, input: $input) {
      ok
      data {
        ...PLAN_ACTION_DETAILS
      }
    }
  }
  ${PLAN_ACTION_DETAILS_FRAGMENT}
`
